import React from 'react';

export const InfoClock = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    width="50"
    height="40"
    viewBox="0 0 50 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.67"
      d="M48.8119 14.1113C51.9995 19.3245 48.1953 27.4568 40.3149 32.2753C32.4345 37.0938 23.4621 36.7738 20.2745 31.5606C17.0869 26.3474 20.8911 18.2152 28.7715 13.3967C36.6518 8.57817 45.6242 8.89814 48.8119 14.1113Z"
      fill="#E8E6FF"
    />
    <g style={{ mixBlendMode: 'multiply' }} opacity="0.67">
      <path
        d="M40.0618 31.8118C36.2497 39.5959 24.4587 41.6451 13.726 36.3889C2.99321 31.1327 -2.61707 20.5615 1.19505 12.7775C5.00717 4.99338 16.7981 2.94412 27.5309 8.20031C38.2636 13.4565 43.8739 24.0277 40.0618 31.8118Z"
        fill="#EFEEF8"
      />
    </g>
    <mask
      id="mask0_165_19260"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="9"
      y="0"
      width="36"
      height="36"
    >
      <rect
        x="9.25684"
        y="0.69696"
        width="34.9929"
        height="34.9929"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0_165_19260)">
      <path
        d="M31.5648 25.0462L33.6061 23.0049L28.2113 17.6102V10.9032H25.2953V18.7766L31.5648 25.0462ZM26.7533 32.7738C24.7363 32.7738 22.8409 32.3908 21.0669 31.6249C19.293 30.8599 17.7499 29.8213 16.4377 28.509C15.1254 27.1968 14.0868 25.6537 13.3218 23.8798C12.5559 22.1058 12.1729 20.2104 12.1729 18.1934C12.1729 16.1765 12.5559 14.281 13.3218 12.5071C14.0868 10.7331 15.1254 9.19003 16.4377 7.8778C17.7499 6.56557 19.293 5.52647 21.0669 4.76051C22.8409 3.99553 24.7363 3.61304 26.7533 3.61304C28.7702 3.61304 30.6657 3.99553 32.4396 4.76051C34.2136 5.52647 35.7567 6.56557 37.0689 7.8778C38.3812 9.19003 39.4198 10.7331 40.1847 12.5071C40.9507 14.281 41.3337 16.1765 41.3337 18.1934C41.3337 20.2104 40.9507 22.1058 40.1847 23.8798C39.4198 25.6537 38.3812 27.1968 37.0689 28.509C35.7567 29.8213 34.2136 30.8599 32.4396 31.6249C30.6657 32.3908 28.7702 32.7738 26.7533 32.7738ZM26.7533 29.8577C29.9853 29.8577 32.7376 28.7219 35.0102 26.4503C37.2818 24.1777 38.4176 21.4254 38.4176 18.1934C38.4176 14.9614 37.2818 12.2091 35.0102 9.93655C32.7376 7.66493 29.9853 6.52911 26.7533 6.52911C23.5213 6.52911 20.7695 7.66493 18.4979 9.93655C16.2253 12.2091 15.089 14.9614 15.089 18.1934C15.089 21.4254 16.2253 24.1777 18.4979 26.4503C20.7695 28.7219 23.5213 29.8577 26.7533 29.8577Z"
        fill="#5D54C0"
      />
    </g>
  </svg>
);
